import React from 'react';
import { Box, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { SAGE, CREAM } from '../../theme';

const F = "'Outfit', sans-serif";

/**
 * AddWidgetCard — dashed placeholder for the "+ Add a widget" tile that
 * sits at the end of a widget grid. Phase 0: visual only.
 */
const AddWidgetCard = ({ label = 'Add a widget', sub = "Track another bet you're placing", onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1.25,
      bgcolor: `${CREAM[50]}80`,
      borderRadius: 3,
      border: `2px dashed ${SAGE[300]}`,
      minHeight: 220,
      p: 2.5,
      textAlign: 'center',
      cursor: onClick ? 'pointer' : 'default',
      transition: 'all 0.15s',
      '&:hover': onClick
        ? { borderColor: SAGE[500], bgcolor: `${CREAM[50]}` }
        : {},
    }}
  >
    <Box
      sx={{
        width: 38,
        height: 38,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: SAGE[100],
        color: SAGE[600],
      }}
    >
      <AddIcon sx={{ fontSize: 22 }} />
    </Box>
    <Typography sx={{ fontFamily: F, fontSize: '0.85rem', fontWeight: 600, color: SAGE[600] }}>
      {label}
    </Typography>
    {sub && (
      <Typography sx={{ fontFamily: F, fontSize: '0.7rem', fontStyle: 'italic', color: SAGE[400], maxWidth: 200 }}>
        {sub}
      </Typography>
    )}
  </Box>
);

export default AddWidgetCard;
